import config from '@/config/prod.env';
import header from '@/helper/header';
import common from '@/helper/common';

const mainUrl = `${process.env.VUE_APP_API_URL}/PentahoLog`;

export default {  
    getAllPagingPentahoErrorJob: async (params) => {
        const requestOptions = {
            method: 'POST',
            headers: await header.authHeaderWithToken(),
            body: JSON.stringify({ 
                "currentPage": params.currentPage,
                "perPage": (params.perPage)? params.perPage : config.DEFAULT_LIMIT,
                "sortBy": (params.sortBy)? params.sortBy: "0",
                "sortDesc": params.sortDesc,
                "searchkey": (params.searchKey)? params.searchKey: ""
            })
        };
    
        let rs = await fetch(`${mainUrl}/GetAllErrorJobPaging`, requestOptions);
        return await common.handleResponse(rs);
    },
    getAllJobRunIndayPaging: async (params) => {
        const requestOptions = {
            method: 'POST',
            headers: await header.authHeaderWithToken(),
            body: JSON.stringify({ 
                "currentPage": params.currentPage,
                "perPage": (params.perPage)? params.perPage : config.DEFAULT_LIMIT,
                "sortBy": (params.sortBy)? params.sortBy: "0",
                "sortDesc": params.sortDesc,
                "searchkey": (params.searchKey)? params.searchKey: ""
            })
        };
    
        let rs = await fetch(`${mainUrl}/GetAllJobRunIndayPaging`, requestOptions);
        return await common.handleResponse(rs);
    },
}